import { render, staticRenderFns } from "./GoArtDialogMsg.vue?vue&type=template&id=5e99cfde&scoped=true"
import script from "./GoArtDialogMsg.vue?vue&type=script&lang=js"
export * from "./GoArtDialogMsg.vue?vue&type=script&lang=js"
import style0 from "./GoArtDialogMsg.vue?vue&type=style&index=0&id=5e99cfde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e99cfde",
  null
  
)

export default component.exports